// extracted by mini-css-extract-plugin
export default {"root":"oMwzGa7V5g0sZwAivLgi"};